var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavExercises(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.833008C13.4205 0.833008 14.167 1.57953 14.167 2.5H15C16.3807 2.5 17.5 3.61929 17.5 5V16.667C17.4998 18.0476 16.3806 19.167 15 19.167H5C3.6194 19.167 2.50018 18.0476 2.5 16.667V5C2.5 3.61929 3.61929 2.5 5 2.5H5.83301C5.83301 1.57953 6.57953 0.833008 7.5 0.833008H12.5ZM5 4.16699C4.53976 4.16699 4.16699 4.53976 4.16699 5V16.667C4.16717 17.1271 4.53987 17.5 5 17.5H15C15.4601 17.5 15.8328 17.1271 15.833 16.667V5C15.833 4.53976 15.4602 4.16699 15 4.16699H14.167C14.1668 5.08732 13.4204 5.83301 12.5 5.83301H7.5C6.57963 5.83301 5.83318 5.08732 5.83301 4.16699H5ZM10 14.167C10.4602 14.167 10.833 14.5398 10.833 15C10.833 15.4602 10.4602 15.833 10 15.833H6.66699C6.20675 15.833 5.83301 15.4602 5.83301 15C5.83301 14.5398 6.20675 14.167 6.66699 14.167H10ZM13.333 10.833C13.7932 10.833 14.167 11.2068 14.167 11.667C14.1668 12.1271 13.7931 12.5 13.333 12.5H6.66699C6.20686 12.5 5.83318 12.1271 5.83301 11.667C5.83301 11.2068 6.20675 10.833 6.66699 10.833H13.333ZM13.333 7.5C13.7931 7.5 14.1668 7.87292 14.167 8.33301C14.167 8.79325 13.7932 9.16699 13.333 9.16699H6.66699C6.20675 9.16699 5.83301 8.79325 5.83301 8.33301C5.83318 7.87292 6.20686 7.5 6.66699 7.5H13.333ZM7.5 2.5V4.16699H12.5V2.5H7.5Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_1101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavExercises);
export default __webpack_public_path__ + "static/media/sidenav-exercises.8bb93b0631191d6fcf6e6cf1f44636ef.svg";
export { ForwardRef as ReactComponent };